module.exports = __webpack_public_path__ + "static/media/arrow_down.6b01b89d.svg";